import { z } from "zod";
const REMINDER_SUBJECT_TYPES = [
  "task",
  "phase",
  "approval_step",
  "event",
  "contract"
];
const ReminderSubjectTypeSchema = z.enum(REMINDER_SUBJECT_TYPES);
const REMINDER_KINDS = ["d-7", "d-2", "d0", "overdue"];
const ReminderKindSchema = z.enum(REMINDER_KINDS);
const REMINDER_TIME_ZONE = "Africa/Tunis";
const REMINDER_LOCAL_HOUR = 8;
const MAX_OVERDUE_REMINDERS = 5;
const DAYS_BEFORE = {
  "d-7": 7,
  "d-2": 2,
  d0: 0
};
const MS_PER_DAY = 864e5;
function addDays(date, days) {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d) + days * MS_PER_DAY).toISOString().slice(0, 10);
}
const formatters = /* @__PURE__ */ new Map();
function formatterFor(timeZone) {
  let formatter = formatters.get(timeZone);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
    formatters.set(timeZone, formatter);
  }
  return formatter;
}
function offsetMs(instant, timeZone) {
  const parts = formatterFor(timeZone).formatToParts(instant);
  const part = (type) => Number(parts.find((p) => p.type === type)?.value ?? "0");
  const local = Date.UTC(
    part("year"),
    part("month") - 1,
    part("day"),
    part("hour"),
    part("minute"),
    part("second")
  );
  return local - Math.floor(instant.getTime() / 1e3) * 1e3;
}
function localInstant(date, hour, timeZone = REMINDER_TIME_ZONE) {
  const [y, m, d] = date.split("-").map(Number);
  const wall = Date.UTC(y, m - 1, d, hour, 0, 0);
  const first = wall - offsetMs(new Date(wall), timeZone);
  return new Date(wall - offsetMs(new Date(first), timeZone));
}
function reminderFireAt(dueOn, kind, occurrence = 0) {
  const day = kind === "overdue" ? addDays(dueOn, 1 + occurrence) : addDays(dueOn, -DAYS_BEFORE[kind]);
  return localInstant(day, REMINDER_LOCAL_HOUR);
}
function planReminders({ dueOn, open, now }) {
  if (!open || dueOn === null) return [];
  return REMINDER_KINDS.map((kind) => ({ kind, fireAt: reminderFireAt(dueOn, kind) })).filter(({ fireAt }) => fireAt.getTime() > now.getTime()).sort((a, b) => a.fireAt.getTime() - b.fireAt.getTime());
}
const EVENT_REMINDER_KINDS = ["start-30m", "start-1d"];
const EventReminderKindSchema = z.enum(EVENT_REMINDER_KINDS);
const EVENT_REMINDER_LEAD_MINUTES = 30;
function localDateOf(instant, timeZone = REMINDER_TIME_ZONE) {
  const parts = formatterFor(timeZone).formatToParts(instant);
  const part = (type) => parts.find((p) => p.type === type)?.value ?? "00";
  return `${part("year")}-${part("month")}-${part("day")}`;
}
const eventReminderKindOf = (allDay) => allDay ? "start-1d" : "start-30m";
function eventReminderFireAt(startsAt, allDay) {
  if (!allDay) return new Date(startsAt.getTime() - EVENT_REMINDER_LEAD_MINUTES * 6e4);
  return localInstant(addDays(localDateOf(startsAt), -1), REMINDER_LOCAL_HOUR);
}
function planEventReminder(input) {
  const fireAt = eventReminderFireAt(input.startsAt, input.allDay);
  if (fireAt.getTime() <= input.now.getTime()) return null;
  return {
    kind: eventReminderKindOf(input.allDay),
    fireAt,
    dueOn: localDateOf(input.startsAt)
  };
}
const BOND_RELEASE_REMINDER_KINDS = ["d-7", "d0"];
function planBondReleaseReminders(input) {
  return planReminders(input).filter(
    ({ kind }) => BOND_RELEASE_REMINDER_KINDS.includes(kind)
  );
}
export {
  BOND_RELEASE_REMINDER_KINDS,
  EVENT_REMINDER_KINDS,
  EVENT_REMINDER_LEAD_MINUTES,
  EventReminderKindSchema,
  MAX_OVERDUE_REMINDERS,
  REMINDER_KINDS,
  REMINDER_LOCAL_HOUR,
  REMINDER_SUBJECT_TYPES,
  REMINDER_TIME_ZONE,
  ReminderKindSchema,
  ReminderSubjectTypeSchema,
  addDays,
  eventReminderFireAt,
  eventReminderKindOf,
  localDateOf,
  localInstant,
  planBondReleaseReminders,
  planEventReminder,
  planReminders,
  reminderFireAt
};
//# sourceMappingURL=index.js.map